module.exports = __webpack_public_path__ + "img/2022-20.372bb0c3.jpg";